import React from 'react';
import Text from 'crehana-ui/Text';
import { connect } from 'react-redux';
import { toggleFilterCategory } from '../../../redux/actions';

import { ItemWrapper } from '../styles';

type SubItem = {
  id: number;
  name: string;
  slug: string;
};

type Category = {
  id: number;
  subItemId: number;
  subItems: { [key: string]: SubItem };
};

type Props = {
  categorySelected: {
    itemId: number;
    subItemId: number;
  };
  categories: { [key: string]: Category };
  toggleFilterCategory(params: { subItemId: number; itemId: number }): void;
  closeDialog(): void;
};

class SubCategories extends React.Component<Props> {
  render() {
    const {
      categories,
      categorySelected,
      toggleFilterCategory: toggleFilterCategoryAction,
      closeDialog,
    } = this.props;

    const subCategories = categories[categorySelected.itemId].subItems;

    return Object.keys(subCategories).map(subItemId => {
      const subCategory = subCategories[subItemId];

      return (
        <ItemWrapper
          key={subItemId}
          onClick={() => {
            toggleFilterCategoryAction({
              itemId: categorySelected.itemId,
              subItemId: parseInt(subItemId, 10),
            });
            closeDialog();
          }}
        >
          <Text type="body2">{subCategory.name}</Text>
        </ItemWrapper>
      );
    });
  }
}

const mapStateToProps = state => ({
  categorySelected: state.filters.categorySelected,
  categories: state.filters.categories,
  state,
});

export default connect(
  mapStateToProps,
  { toggleFilterCategory },
)(SubCategories);
